export default __webpack_public_path__ + "static/media/Roulette.4420dd5f.mp3";